import { Component } from "react";

const title = "All Categories";

class Categorie extends Component {
  render() {
    const { onCategoryChange, activeCategories } = this.props;

    return (
      <div className="widget shop-widget">
        <div className="widget-header">
          <h5>{title}</h5>
        </div>

        <div className="widget-wrapper">
          <ul className="shop-menu lab-ul">

            <li
              className={activeCategories?.includes("jersey") ? "active" : ""}
              onClick={() => onCategoryChange("jersey")}
            >
              Jersey
            </li>

            <li
              className={activeCategories?.includes("mousepad") ? "active" : ""}
              onClick={() => onCategoryChange("mousepad")}
            >
              Mousepad
            </li>

            <li
              className={activeCategories?.includes("hoodie") ? "active" : ""}
              onClick={() => onCategoryChange("hoodie")}
            >
              Hoodie
            </li>

            <li
              className={activeCategories?.includes("shirt") ? "active" : ""}
              onClick={() => onCategoryChange("shirt")}
            >
              Shirt
            </li>

            <li
              className={activeCategories?.includes("beaniehat") ? "active" : ""}
              onClick={() => onCategoryChange("beaniehat")}
            >
              Beanies & Hats
            </li>

            <li
              className={activeCategories?.includes("sticker") ? "active" : ""}
              onClick={() => onCategoryChange("sticker")}
            >
              Sticker & Posters
            </li>

            <li
              className={activeCategories?.includes("signedmerch") ? "active" : ""}
              onClick={() => onCategoryChange("signedmerch")}
            >
              Signed Merch
            </li>

          </ul>
        </div>
      </div>
    );
  }
}

export default Categorie;
